import { useDocumentTitle } from '@/hooks/useDocumentTitle';
import KioskGameProviders from '@/features/games/components/KioskGameProviders';

export default function Home() {
  useDocumentTitle('Vault Play - Home');
  return (
    <KioskGameProviders />
  );
}
